import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';
import { minimaxSystemVoices } from './voices/minimax-voices';

// 系数
const COST_FACTOR = 2;

export const minimaxModels: Record<string, TersaSpeechModel> = {
    'minimax-music-2.6': {
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-music-2.6'),
                getCost: () => {
                    return 0.15 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics'],
        precheck: ['prompt', 'lyrics'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'minimax-music-3.0': {
        default: true,
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-music-3.0'),
                getCost: () => {
                    return 0.15 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics'],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'minimax-music-cover': {
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-music-cover'),
                getCost: () => {
                    return 0.15 * COST_FACTOR;
                },
            },
        ],
        voices: [],
        precheck: ['prompt', 'audio'],
        supportsInput: ['a2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'minimax-voice-clone': {
        promptLabel: 'Text',
        lyricsLabel: 'Voice ID',
        lyricsPlaceholder: 'audio.voice_id.placeholder',
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-voice-clone'),
                getCost: () => {
                    return 0.5 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics'],
        precheck: ['prompt', 'lyrics', 'audio'],
        supportsInput: ['a2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'minimax-speech-2.8-turbo': {
        promptLabel: 'Text',
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-speech-2.8-turbo'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 1000));
                    return units * 0.06 * COST_FACTOR;
                },
            },
        ],
        voices: minimaxSystemVoices,
        voiceLabelPrefix: 'audio.voice.minimax',
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'minimax-speech-2.8-hd': {
        promptLabel: 'Text',
        chef: providers.minimax,
        providers: [
            {
                ...providers.minimax,
                model: wavespeed.speech('minimax-speech-2.8-hd'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 1000));
                    return units * 0.1 * COST_FACTOR;
                },
            },
        ],
        voices: minimaxSystemVoices,
        voiceLabelPrefix: 'audio.voice.minimax',
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};